import { DEFAULT_ROLE_TOKEN_HEADER } from "@hg/one-account"

import { auth } from "@/utils/auth"
import request from "@/utils/request"

export const getGameBasicInfo = async () => {}

const prefix = "/api/topic/rogue_4"

export function getRollInfo(): Promise<{
    code: number
    data: Rogue4RollInfo
    msg: string
}> {
    return request.get(`${prefix}/info`, {
        headers: {
            [DEFAULT_ROLE_TOKEN_HEADER]: auth.getToken(),
        },
    })
}

export function completeGame(): Promise<{
    code: number
    msg: string
}> {
    return request.post(
        `${prefix}/game/complete`,
        {},
        {
            headers: {
                [DEFAULT_ROLE_TOKEN_HEADER]: auth.getToken(),
            },
        }
    )
}

export function draw(): Promise<{
    code: number
    data: {
        bingo: boolean
        awardId: string
    }
    msg: string
}> {
    return request.post(
        `${prefix}/draw`,
        {},
        {
            headers: {
                [DEFAULT_ROLE_TOKEN_HEADER]: auth.getToken(),
            },
        }
    )
}

export function fill(contactInfo: ContactInfo): Promise<{
    code: number
    msg: string
}> {
    return request.post(`${prefix}/fill`, contactInfo, {
        headers: {
            [DEFAULT_ROLE_TOKEN_HEADER]: auth.getToken(),
        },
    })
}

export function getSaveData(): Promise<{
    code: number
    data: Rogue4SaveData
    msg: string
}> {
    return request.get(`${prefix}/game/saveData`, {
        headers: {
            [DEFAULT_ROLE_TOKEN_HEADER]: auth.getToken(),
        },
    })
}

export enum Rogue4UpdateType {
    ITEM = "item",
    EQUIPMENT = "equipment",
    ENDING = "ending",
}

export function updateSaveData(
    type: Rogue4UpdateType,
    value: string
): Promise<{
    code: number
    msg: string
}> {
    return request.post(
        `${prefix}/game/saveData`,
        {
            type,
            value,
        },
        {
            headers: {
                [DEFAULT_ROLE_TOKEN_HEADER]: auth.getToken(),
            },
        }
    )
}
